module.exports = __webpack_public_path__ + "static/media/home.ba6bada6.svg";